import { CSSProperties, MouseEventHandler, useCallback, useState } from 'react';

import { Team } from '../../types';
import { Player } from '../../types/players';
import PlayerReservationDetailsModal from '../modals/PlayerReservationDetailsModal';
import TeamDrawer from '../modals/TeamDrawer';
import { useTranslation } from 'react-i18next';
import { COMMON_TRANSLATE_KEYS } from '../../constants/translate-keys';
import { createPortal } from 'react-dom';

type Props = {
  group: Team;
  openDrawer: boolean;
  setOpenDrawer: (open: boolean) => void;
  onDiscardClick?: MouseEventHandler<HTMLButtonElement>;
  style?: CSSProperties;
};

const GroupBar = ({
  group: team,
  style,
  onDiscardClick,
  openDrawer,
  setOpenDrawer,
}: Props) => {
  const [selectedPlayer, setSelectedPlayer] = useState<Player | null>(null);

  const { t } = useTranslation();

  const handleCloseDrawer = useCallback(() => {
    setSelectedPlayer(null);
    setOpenDrawer(false);
  }, [setOpenDrawer]);

  const renderIcon = useCallback(() => {
    if (team) {
      const { logoUrl } = team;

      if (logoUrl) {
        return (
          <img
            src={logoUrl}
            alt="group"
            className="mr-4 w-[40px] h-[40px] object-cover flex flex-shrink-0 border-4 border-dividerGray rounded-md"
            width={36}
            height={36}
          />
        );
      }
    }

    return (
      <div className="mr-4 w-[40px] h-[40px] rounded-md border-4 border-dividerGray bg-mainBlack"></div>
    );
  }, [team]);

  return (
    <>
      <div
        className="relative flex flex-row items-center py-2 px-4 border-y border-dividerGray gap-5 hover:bg-additionalBlack rounded-lg max-h-[52px]"
        style={style}
      >
        <button
          onClick={() => setOpenDrawer(true)}
          className="flex flex-row items-center w-[90%]"
          type="button"
        >
          {renderIcon()}
          <p className="text-white whitespace-break-spaces">
            {`${t(COMMON_TRANSLATE_KEYS.TEAM)} ${team.name}`}
          </p>
        </button>
        <div className="flex w-[10%] justify-center">
          <button
            type="button"
            className="text-textGray hover:text-white"
            onClick={onDiscardClick}
          >
            X
          </button>
        </div>
      </div>

      {createPortal(
        <TeamDrawer
          drawerOpen={openDrawer}
          team={team}
          onPlayerClick={setSelectedPlayer}
          handleCloseDrawer={handleCloseDrawer}
        />,
        document.body
      )}

      {!!selectedPlayer && (
        <PlayerReservationDetailsModal
          close={() => setSelectedPlayer(null)}
          player={selectedPlayer}
          team={team}
        />
      )}
    </>
  );
};

export default GroupBar;
